module.exports = __webpack_public_path__ + "static/media/Boo.201513c4.png";